import { Description } from '@mui/icons-material'
import { styled } from '@mui/material'
import ReactPdfViewer from '../../../../shared/components/frontoffice/ReactPdfViewer'

const Img = styled('img')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    borderRadius: 8,
    maxWidth: '80%',
    display: 'block',
    margin: '0 auto'
  },
  [theme.breakpoints.down('sm')]: {
    maxWidth: '100%',
    borderRadius: 8
  }
}))

const MediaBox = styled('div')(({ theme }) => ({
  background: theme.palette.grey[50],
  borderRadius: '8px 8px 8px 0px',
  backgroundSize: 'cover !important',
  backgroundPosition: 'center !important',
  backgroundColor: theme.palette.grey[100],
  position: 'relative',
  width: '100%',
  paddingTop: '56.25%',
  overflow: 'hidden',
  '& svg': {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    color: theme.palette.grey[400],
    fontSize: '65px'
  },
  [theme.breakpoints.up('md')]: {
    borderRadius: '8px'
  }
}))

function TypeFileView({ file, type }: { file: any; type: string }) {
  const TypeFile = () => {
    const fileNameExtension = file.ext === null ? '' : file.ext.toLowerCase()

    const $imageExtensions = ['jpg', 'gif', 'png', 'jpeg', 'bmp', 'jfif', 'tif', 'webp']
    const $fileExtensions = ['pdf', '']
    const $videoExtensions = ['mp4', 'mov', 'wmv', 'avi']
    const uri = `${import.meta.env.VITE_AWS_URL}/${type}/webp/${file.file_name}`

    if ($imageExtensions.includes(fileNameExtension)) {
      return <Img src={`${encodeURI(uri)}`} title={file.file_name} alt={file.file_name} />
    }

    if ($videoExtensions.includes(fileNameExtension)) {
      return (
        <MediaBox>
          <video
            controls
            style={{
              position: 'absolute',
              top: '0',
              left: '0',
              width: '100%',
              height: '100%',
              objectFit: 'contain'
            }}
          >
            <source src={uri} type={`video/${fileNameExtension === 'mov' ? 'quicktime' : fileNameExtension}`} />
            Your browser does not support HTML <code>video</code>.
          </video>
        </MediaBox>
      )
    }

    if ($fileExtensions.includes(fileNameExtension)) {
      return <ReactPdfViewer fileName={file.file_name} fileUrl={uri} />
    }

    return (
      <MediaBox className="detail">
        <Description fontSize="large" color="inherit" />
      </MediaBox>
    )
  }

  return <TypeFile />
}

export default TypeFileView
